// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_task_provenance.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureTaskView } from "./projectdata_pb";
/**
 * @generated from message mono.projectdata.v1.CaptureTaskProvenanceView
 */ export class CaptureTaskProvenanceView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTaskProvenanceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTaskProvenanceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTaskProvenanceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTaskProvenanceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string task_id = 1;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: string area_key = 2;
   */ _define_property(this, "areaKey", ""), /**
   * manual | area | go_no_go | interaction
   *
   * @generated from field: string origin_kind = 3;
   */ _define_property(this, "originKind", ""), /**
   * @generated from field: string origin_ref_id = 4;
   */ _define_property(this, "originRefId", ""), /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 5;
   */ _define_property(this, "assignedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTaskProvenanceView, "runtime", proto3);
_define_property(CaptureTaskProvenanceView, "typeName", "mono.projectdata.v1.CaptureTaskProvenanceView");
_define_property(CaptureTaskProvenanceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "origin_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "origin_ref_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assigned_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTaskProvenanceRequest
 */ export class ListCaptureTaskProvenanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTaskProvenanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTaskProvenanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTaskProvenanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTaskProvenanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTaskProvenanceRequest, "runtime", proto3);
_define_property(ListCaptureTaskProvenanceRequest, "typeName", "mono.projectdata.v1.ListCaptureTaskProvenanceRequest");
_define_property(ListCaptureTaskProvenanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureTaskProvenanceResponse
 */ export class ListCaptureTaskProvenanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTaskProvenanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTaskProvenanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTaskProvenanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTaskProvenanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureTaskProvenanceView provenance = 1;
   */ _define_property(this, "provenance", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTaskProvenanceResponse, "runtime", proto3);
_define_property(ListCaptureTaskProvenanceResponse, "typeName", "mono.projectdata.v1.ListCaptureTaskProvenanceResponse");
_define_property(ListCaptureTaskProvenanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "provenance",
            kind: "message",
            T: CaptureTaskProvenanceView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTaskProvenanceRequest
 */ export class SetCaptureTaskProvenanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskProvenanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskProvenanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskProvenanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskProvenanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string task_id = 2;
   */ _define_property(this, "taskId", ""), /**
   * Empty clears the area. Otherwise a Capture Plan area id of this pursuit.
   *
   * @generated from field: string area_key = 3;
   */ _define_property(this, "areaKey", ""), /**
   * @generated from field: string origin_kind = 4;
   */ _define_property(this, "originKind", ""), /**
   * @generated from field: string origin_ref_id = 5;
   */ _define_property(this, "originRefId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskProvenanceRequest, "runtime", proto3);
_define_property(SetCaptureTaskProvenanceRequest, "typeName", "mono.projectdata.v1.SetCaptureTaskProvenanceRequest");
_define_property(SetCaptureTaskProvenanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "origin_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin_ref_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetCaptureTaskProvenanceResponse
 */ export class SetCaptureTaskProvenanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskProvenanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskProvenanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskProvenanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskProvenanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureTaskProvenanceView provenance = 1;
   */ _define_property(this, "provenance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskProvenanceResponse, "runtime", proto3);
_define_property(SetCaptureTaskProvenanceResponse, "typeName", "mono.projectdata.v1.SetCaptureTaskProvenanceResponse");
_define_property(SetCaptureTaskProvenanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "provenance",
            kind: "message",
            T: CaptureTaskProvenanceView
        }
    ]));
/**
 * A follow-up is an explicit adoption, never an AI suggestion or access grant.
 *
 * @generated from message mono.projectdata.v1.CustomerFollowUp
 */ export class CustomerFollowUp extends Message {
    static fromBinary(bytes, options) {
        return new CustomerFollowUp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerFollowUp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerFollowUp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerFollowUp, a, b);
    }
    constructor(data){
        super(), /**
   * interaction | theme
   *
   * @generated from field: string source_kind = 1;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 2;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string statement = 3;
   */ _define_property(this, "statement", ""), /**
   * @generated from field: string context_snapshot = 4;
   */ _define_property(this, "contextSnapshot", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureTaskView task = 5;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerFollowUp, "runtime", proto3);
_define_property(CustomerFollowUp, "typeName", "mono.projectdata.v1.CustomerFollowUp");
_define_property(CustomerFollowUp, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_snapshot",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "task",
            kind: "message",
            T: CaptureTaskView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptCustomerFollowUpRequest
 */ export class AdoptCustomerFollowUpRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptCustomerFollowUpRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptCustomerFollowUpRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptCustomerFollowUpRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptCustomerFollowUpRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 3;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string statement = 4;
   */ _define_property(this, "statement", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner_user_id = 6;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 7;
   */ _define_property(this, "dueAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptCustomerFollowUpRequest, "runtime", proto3);
_define_property(AdoptCustomerFollowUpRequest, "typeName", "mono.projectdata.v1.AdoptCustomerFollowUpRequest");
_define_property(AdoptCustomerFollowUpRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "statement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptCustomerFollowUpResponse
 */ export class AdoptCustomerFollowUpResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptCustomerFollowUpResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptCustomerFollowUpResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptCustomerFollowUpResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptCustomerFollowUpResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CustomerFollowUp follow_up = 1;
   */ _define_property(this, "followUp", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptCustomerFollowUpResponse, "runtime", proto3);
_define_property(AdoptCustomerFollowUpResponse, "typeName", "mono.projectdata.v1.AdoptCustomerFollowUpResponse");
_define_property(AdoptCustomerFollowUpResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "follow_up",
            kind: "message",
            T: CustomerFollowUp
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerFollowUpsRequest
 */ export class ListCustomerFollowUpsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerFollowUpsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerFollowUpsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerFollowUpsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerFollowUpsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 3;
   */ _define_property(this, "sourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerFollowUpsRequest, "runtime", proto3);
_define_property(ListCustomerFollowUpsRequest, "typeName", "mono.projectdata.v1.ListCustomerFollowUpsRequest");
_define_property(ListCustomerFollowUpsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCustomerFollowUpsResponse
 */ export class ListCustomerFollowUpsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerFollowUpsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerFollowUpsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerFollowUpsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerFollowUpsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CustomerFollowUp follow_ups = 1;
   */ _define_property(this, "followUps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerFollowUpsResponse, "runtime", proto3);
_define_property(ListCustomerFollowUpsResponse, "typeName", "mono.projectdata.v1.ListCustomerFollowUpsResponse");
_define_property(ListCustomerFollowUpsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "follow_ups",
            kind: "message",
            T: CustomerFollowUp,
            repeated: true
        }
    ]));
